import { useState } from 'react';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  // Fonction pour fermer le menu quand on clique sur un lien
  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <header className="font-inria fixed top-0 left-0 right-0 z-50 md:bg-gradient-to-b md:from-white md:to-transparent md:hover:bg-white transition-all duration-300 md:hover:shadow-lg">
      <div className="h-16 md:h-20 w-full px-4 md:px-6 lg:px-8 xl:px-18 flex items-center justify-end md:justify-center">
        {/* Menu Desktop */}
        <nav className="hidden md:flex justify-center items-center gap-2 lg:gap-4">
          <a href="/" className="underline underline-offset-8 decoration-1 text-black font-inria font-light text-lg md:text-xl lg:text-2xl transition duration-300 hover:text-purple-500">
            Accueil
          </a>
          <a href="/#Projets" className="text-black font-inria underline underline-offset-8 decoration-1 text-black font-light text-lg md:text-xl lg:text-2xl p-2 md:p-3 lg:p-4 transition duration-300 hover:text-purple-500">
            Projets
          </a>
          <a href="/#Contact" className="text-black font-inria font-light underline underline-offset-8 decoration-1 text-black text-lg md:text-xl lg:text-2xl transition duration-300 hover:text-purple-500">
            Contact
          </a>
        </nav>

        {/* Bouton hamburger pour mobile - maintenant en noir */}
        <button
          onClick={() => setIsOpen(true)}
          type="button"
          className="text-black mt-3 p-2 shadow-xl rounded-xl bg-white focus:outline-none md:hidden hover:text-purple-500 transition-colors"
          aria-label="Ouvrir le menu"
        >
          <svg
            className="w-10 h-10"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Menu mobile qui s'ouvre du haut vers le bas */}
      <div
        className={`fixed top-0 left-0 right-0 bg-white shadow-xl transform transition-transform duration-300 z-40 ${
          isOpen ? '-translate-y-10' : '-translate-y-full'
        } md:hidden`}
      >
        <div className="pt-16 md:pt-20 px-4 pb-8">
          <div className="flex justify-end mb-4 ">
            <button
              onClick={() => setIsOpen(false)}
              className="bg-white text-black focus:outline-none hover:text-purple-500 transition-colors"
              aria-label="Fermer le menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <nav className="flex flex-col items-center space-y-6">
            <a 
              href="/" 
              onClick={handleLinkClick}
              className="underline underline-offset-8 decoration-1 text-black font-inria font-light text-lg md:text-xl lg:text-2xl transition duration-300 hover:text-purple-500"
            >
              Accueil
            </a>
            <a 
              href="/#Projets" 
              onClick={handleLinkClick}
              className="text-black font-inria underline underline-offset-8 decoration-1 text-black font-light text-lg md:text-xl lg:text-2xl p-2 md:p-3 lg:p-4 transition duration-300 hover:text-purple-500"
            >
              Projets
            </a>
            <a 
              href="/#Contact" 
              onClick={handleLinkClick}
              className="text-black font-inria font-light underline underline-offset-8 decoration-1 text-black text-lg md:text-xl lg:text-2xl transition duration-300 hover:text-purple-500"
            >
              Contact
            </a>
          </nav>
        </div>
      </div>

      {/* Overlay pour fermer le menu en cliquant à l'extérieur */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </header>
  );
}